import { render, staticRenderFns } from "./DadosGuiaDlg.vue?vue&type=template&id=decd918a"
import script from "./DadosGuiaDlg.vue?vue&type=script&lang=js"
export * from "./DadosGuiaDlg.vue?vue&type=script&lang=js"
import style0 from "./DadosGuiaDlg.vue?vue&type=style&index=0&id=decd918a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports